// src/utils.ts
function metersToInches(m) {
  return m * 39.3701;
}
function metersToFeet(m) {
  return m * 3.28084;
}
function cubicMetersToCubicFeet(m3) {
  return m3 * 35.3147;
}
function eulerToQuaternion(x, y, z) {
  const c1 = Math.cos(x / 2);
  const c2 = Math.cos(y / 2);
  const c3 = Math.cos(z / 2);
  const s1 = Math.sin(x / 2);
  const s2 = Math.sin(y / 2);
  const s3 = Math.sin(z / 2);
  return {
    x: s1 * c2 * c3 + c1 * s2 * s3,
    y: c1 * s2 * c3 - s1 * c2 * s3,
    z: c1 * c2 * s3 + s1 * s2 * c3,
    w: c1 * c2 * c3 - s1 * s2 * s3
  };
}

export { cubicMetersToCubicFeet, eulerToQuaternion, metersToFeet, metersToInches };
//# sourceMappingURL=utils.mjs.map
//# sourceMappingURL=utils.mjs.map